import { StepsButtons } from "@/components/button/steps-button";
import { ProfilePageContainer } from "@/components/container/profile-page-container";
import { PageTitleComponent } from "@/components/page-title";
import { useStepRouteInfo } from "@/hooks/use-step-route-info";

const ProfilingKnowYou = () => {
  const { info } = useStepRouteInfo();
  return (
    <ProfilePageContainer className="gap-4 items-center justify-center h-full">
      <div className="flex flex-col items-center justify-center w-48 h-48 bg-secondary-light rounded-full">
        <img
          src="/assets/icons/menu.png"
          alt="plan-for-you"
          className="w-48 h-48 object-cover"
        />
      </div>
      <PageTitleComponent
        title="Let’s get to know how you live, so we can build around it."
        description="We’’ll use your answers to create a nutrition companion that fits your real life not someone else’s. It take under a minute."
        align="center"
        titleAlign="center"
        descriptionAlign="center"
      />
      <StepsButtons
        previousPath={info?.previousPath}
        nextPath={info?.nextPath}
      />
    </ProfilePageContainer>
  );
};

export default ProfilingKnowYou;
